export default __webpack_public_path__ + "static/media/Sleeve Upper Left.93a97d87.jpg";